import {
  cardTitle,
  container,
  whiteColor,
  blackColor,
  hexToRgb
} from 'assets/jss/emjayTheme.js';
import { boxShadow, primaryColor } from 'assets/jss/emjayTheme';
import margin from 'assets/scss/custom/margin.module.scss';

const itemDetailsDrawerStyle = theme => ({
  cardTitle,
  container: {
    paddingBottom: '75px!important',
    overflowY: 'auto',
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
      height: '70vh',
      padding: '20px'
    },
    [theme.breakpoints.up('sm')]: {
      width: '322px',
      padding: '20px'
    }
  },
  loading: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinner: {
    color: primaryColor[2]
  },
  saveButtonContainer: {
    position: 'fixed',
    bottom: 0,
    width: 'inherit',
    right: 0,
    padding: 17,
    zIndex: 2,
    background: 'white',
    WebkitBoxShadow: '0px -4px 3px rgba(50, 50, 50, 0.05)',
    MozBoxShadow: '0px -4px 3px rgba(50, 50, 50, 0.05)',
    boxShadow: '0px -4px 3px rgba(50, 50, 50, 0.05)'
  },
  saveButton: {
    // padding: '16px 0',
    fontWeight: 500,
    fontSize: '14px'
  },
  details: {
    '& img': {
      width: '100%'
    }
  },
  label: {
    marginLeft: 8,
    '&$checked': {
      webkitAppearance: 'none',
      appearance: 'none',
      backgroundColor: '#fa6446'
    }
  },
  deal: {
    padding: '8px 12px',
    background: '#f8f8f8',
    marginBottom: 'calc(1rem + 8px)',
    borderRadius: '6px'
  },
  divider: {
    marginTop: '0.5rem'
  },
  flex: {
    display: 'flex'
  },
  checked:{}
});

export default itemDetailsDrawerStyle;
